import React, { Component, Fragment } from 'react'
import Grid from '@material-ui/core/Grid';
import GaugeDB from '../../../graphics/containers/GaugeDB';

export default class GraphicsStaticContainer extends Component {
  // state = {
  //   show: true
  // }
  // componentWillReceiveProps(nextProps) {
  //   // You don't have to do this check first, but it can help prevent an unneeded render
  //   this.setState({ show: true });
  //   setTimeout(
  //     function() {
  //         this.setState({show: false});
  //     }
  //     .bind(this),
  //     3000
  // );
  // }
  handleGrapStatic(objeto) {
    if (typeof objeto === "undefined" || objeto === null) {
      return (<div></div>); //<div>{this.state.show && <Loader />}</div>
    }
    return objeto.filter((val) => !!val.dataSet.length)
      .map((val, index) => {
        return (
          <Fragment key={'grid-gauge-' + index}>
            <Grid className='chartColList' item xs={12} lg={(this.props.anchoMap) ? 12 : 6} >
              <GaugeDB
                name={val.name}
                title={val.title}
                data={val.dataSet}
                date={val.date}
                openDialog={this.props.openDialog}
                onClickGraphic={this.props.onClickGraphic}
                seeMore={false}
              />
            </Grid>
          </Fragment>
        )
      });

  }

  render() {
    const objeto = this.props.dataResult;
    return (
      <Grid container >
        {
          this.handleGrapStatic(objeto)
        }
      </Grid>

    )
  }
}